import { getTestimonials, saveTestimonial, deleteTestimonial } from '../../../lib/cms'

const emptyItem = { name: '', role: '', text: '', avatar: '', sort_order: 0 }

export default function AdminTestimonials() {
  const [items, setItems] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [editItem, setEditItem] = useState<any | null>(null)
  const [saving, setSaving] = useState(false)
  const [deleteId, setDeleteId] = useState<number | null>(null)
  const [msg, setMsg] = useState('')

  const load = async () => {
    setLoading(true)
    setItems(await getTestimonials())
    setLoading(false)
  }
  useEffect(() => { load() }, [])

  const flash = (m: string) => { setMsg(m); setTimeout(() => setMsg(''), 3000) }

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!editItem) return
    setSaving(true)
    await saveTestimonial(editItem)
    await load()
    setEditItem(null)
    flash('Testimonijal sačuvan!')
    setSaving(false)
  }

  const handleDelete = async () => {
    if (!deleteId) return
    await deleteTestimonial(deleteId)
    await load()
    setDeleteId(null)
    flash('Testimonijal obrisan.')
  }

  return (
    <div className="space-y-4">
      {msg && <div className="bg-green-50 border border-green-200 text-green-800 rounded-lg px-4 py-2 text-sm">{msg}</div>}

      <div className="flex items-center justify-between">
        <p className="text-gray-500 text-sm">{items.length} testimonijala</p>
        <button
          onClick={() => setEditItem({ ...emptyItem })}
          className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-4 py-2 rounded-lg flex items-center gap-2 transition"
        >
          <i className="ri-add-line" /> Dodaj testimonijal
        </button>
      </div>

      {loading ? (
        <div className="text-center py-12 text-gray-400"><i className="ri-loader-4-line animate-spin text-2xl" /></div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-4">
          {items.map((t, idx) => (
            <div key={t.id ?? idx} className="bg-white rounded-xl border border-gray-200 p-4">
              <div className="flex items-start gap-3 mb-3">
                {t.avatar
                  ? <img src={t.avatar} alt="" className="w-12 h-12 rounded-full object-cover flex-shrink-0" />
                  : <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center text-gray-400 flex-shrink-0"><i className="ri-user-line text-xl" /></div>
                }
                <div>
                  <p className="font-medium text-gray-900 text-sm">{t.name}</p>
                  <p className="text-gray-500 text-xs">{t.role}</p>
                </div>
                <div className="ml-auto flex items-center gap-2">
                  <button onClick={() => setEditItem({ ...t })} className="text-gray-400 hover:text-blue-600 transition p-1"><i className="ri-edit-line" /></button>
                  <button onClick={() => setDeleteId(t.id)} className="text-gray-400 hover:text-red-500 transition p-1"><i className="ri-delete-bin-line" /></button>
                </div>
              </div>
              <p className="text-gray-600 text-sm italic line-clamp-3">"{t.text}"</p>
            </div>
          ))}
        </div>
      )}

      {editItem && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-start justify-center p-4 overflow-y-auto">
          <div className="bg-white rounded-2xl w-full max-w-lg my-8">
            <div className="flex items-center justify-between p-6 border-b">
              <h2 className="font-semibold text-gray-900">{editItem.id ? 'Uredi testimonijal' : 'Novi testimonijal'}</h2>
              <button onClick={() => setEditItem(null)} className="text-gray-400 hover:text-gray-600"><i className="ri-close-line text-xl" /></button>
            </div>
            <form onSubmit={handleSave} className="p-6 space-y-4">
              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Ime *</label>
                  <input className="input" value={editItem.name} onChange={e => setEditItem({ ...editItem, name: e.target.value })} required />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Uloga / firma</label>
                  <input className="input" value={editItem.role} onChange={e => setEditItem({ ...editItem, role: e.target.value })} placeholder="npr. CEO, Firma d.o.o." />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">URL avatara</label>
                <input className="input" value={editItem.avatar} onChange={e => setEditItem({ ...editItem, avatar: e.target.value })} placeholder="https://..." />
                {editItem.avatar && <img src={editItem.avatar} alt="" className="mt-2 w-14 h-14 rounded-full object-cover" />}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Tekst utiska *</label>
                <textarea className="input" rows={4} value={editItem.text} onChange={e => setEditItem({ ...editItem, text: e.target.value })} required />
              </div>
              <div className="flex justify-end gap-3 pt-2">
                <button type="button" onClick={() => setEditItem(null)} className="px-4 py-2 text-sm text-gray-600">Otkaži</button>
                <button type="submit" disabled={saving} className="bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white text-sm font-medium px-6 py-2 rounded-lg transition">
                  {saving ? 'Čuvanje...' : 'Sačuvaj'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {deleteId && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl p-6 max-w-sm w-full">
            <h3 className="font-semibold text-gray-900 mb-2">Obriši testimonijal?</h3>
            <p className="text-gray-500 text-sm mb-5">Ova akcija je trajna.</p>
            <div className="flex gap-3 justify-end">
              <button onClick={() => setDeleteId(null)} className="px-4 py-2 text-sm text-gray-600">Otkaži</button>
              <button onClick={handleDelete} className="bg-red-600 hover:bg-red-700 text-white text-sm font-medium px-4 py-2 rounded-lg transition">Obriši</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
